var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['material-icons-round v-icon', { 'rtl-flip': _vm.rtlFlip }],style:({
    fontSize: _vm.size,
    color: _vm.color
  }),attrs:{"translate":"no"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }